import { Sparkles, Check } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function Membership() {
  const { settings } = useSettings();
  const PATREON_URL = settings.patreon_url || "https://patreon.com/SVNNetwork";

  const perks = [
    "Early access to new episodes",
    "Bonus episodes & uncut conversations",
    "Behind the scenes & raw footage",
    "Live Q&A with hosts and guests",
    "Members-only community access",
    "Exclusive SVN+ drops & merch pre-orders",
  ];

  return (
    <div data-testid="membership-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1708457753320-02e52a276a80?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/40" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold mb-4 inline-flex items-center gap-2">
            <Sparkles size={14} /> SVN+ Membership
          </p>
          <h1 className="font-display text-5xl md:text-8xl font-black tracking-tighter leading-none max-w-4xl">
            Join the <span className="text-gold">inner signal.</span>
          </h1>
          <p className="mt-8 text-xl text-neutral-300 max-w-2xl font-body">
            Become part of the community keeping the SVN Network independent. More access. More content. Direct line to the network.
          </p>

          <div className="mt-12 max-w-4xl bg-black/60 backdrop-blur-xl border border-gold/30 p-8 md:p-12" data-testid="membership-card">
            <p className="font-display text-3xl md:text-4xl font-black tracking-tight">
              Membership <span className="text-gold">perks.</span>
            </p>
            <ul className="mt-8 grid md:grid-cols-2 gap-4">
              {perks.map((p) => (
                <li key={p} className="flex items-start gap-3 text-neutral-200">
                  <Check className="text-gold mt-0.5 shrink-0" size={18} />
                  <span className="font-body">{p}</span>
                </li>
              ))}
            </ul>
            <a
              href={PATREON_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="join-svn-plus-btn"
              className="mt-12 inline-flex items-center gap-3 bg-gold text-black font-black uppercase tracking-widest text-sm px-10 py-5 hover:shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-all"
            >
              Become A Member
            </a>
            <p className="mt-4 text-xs text-neutral-500 font-body">Hosted on Patreon. Cancel anytime.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
